<template><div /></template>

<script>
import { getTokenByPartnerIDT } from "@/api/login";

export default {
  name: "loginpIdt",

  methods: {
    /**
     * 使用伙伴 IDT 授权码完成知识库登录。
     *
     * @param {string} hostName 当前访问域名
     * @param {string} mlHost 马来站点域名
     * @returns {Promise<void>} 登录请求
     */
    loginByCode(hostName, mlHost) {
      const isEu = hostName !== mlHost;
      const request = {
        code: this.$route.query.code,
        redirectUri: isEu
          ? process.env.VUE_APP_PARTNER_EU_REDIRECT_URI
          : process.env.VUE_APP_PARTNER_REDIRECT_URI,
        type: isEu ? "eu" : "mo",
      };

      return getTokenByPartnerIDT(request)
        .then((response) => {
          if (response.status !== 200 || !this.saveSession(response.data)) {
            this.showLoginError();
            return;
          }

          this.$router.push({ path: "/home" });
        })
        .catch(() => {
          this.showLoginError();
          this.$router.replace({ path: "/home" });
        });
    },

    /**
     * 保存知识库伙伴登录会话。
     *
     * @param {Object} data 登录接口返回的数据
     * @returns {boolean} 登录数据完整并成功保存时返回 true
     */
    saveSession(data) {
      const idtToken = data && data.idtToken;
      const accessToken = data && data.token && data.token.access_token;
      const userInfo = data && data.userInfo;

      if (!idtToken || !accessToken || !userInfo) {
        return false;
      }

      // IDT 令牌仅用于退出上游会话，本地接口统一使用本地访问令牌。
      localStorage.setItem("token_by_code", idtToken);
      localStorage.setItem("library_token", accessToken);
      localStorage.setItem("library_userInfo", JSON.stringify(userInfo));
      this.$store.commit("SET_USERINFO", userInfo);
      return true;
    },

    /**
     * 跳转到对应区域的伙伴 IDT 授权页面。
     *
     * @param {string} hostName 当前访问域名
     * @param {string} mlHost 马来站点域名
     * @returns {void}
     */
    redirectToPartnerIdt(hostName, mlHost) {
      const isEu = hostName !== mlHost;
      const origin = isEu
        ? process.env.VUE_APP_EU_LOGIN
        : process.env.VUE_APP_CAS_LOGIN;
      const redirectUri = isEu
        ? process.env.VUE_APP_PARTNER_EU_REDIRECT_URI
        : process.env.VUE_APP_PARTNER_REDIRECT_URI;

      if (!origin || !redirectUri) {
        this.$message.error("Partner authentication configuration is missing");
        this.$router.replace({ path: "/home" });
        return;
      }

      localStorage.setItem("library_login_type", "partner");
      window.location.replace(
        `${origin}&redirect_uri=${encodeURIComponent(redirectUri)}`
      );
    },

    /**
     * 显示统一的伙伴登录失败提示。
     *
     * @returns {void}
     */
    showLoginError() {
      this.$message.warning("Partner login failed. Please try again");
    },
  },

  /**
   * 根据回调参数继续登录或发起伙伴 IDT 授权。
   *
   * @returns {void}
   */
  created() {
    const { VUE_APP_ML_HOST } = process.env;
    const hostName = window.location.hostname;

    // IDT 返回错误时不能再次发起授权，否则会形成重定向循环。
    if (this.$route.query.error) {
      this.$message.error("Partner authentication failed. Please sign in again");
      this.$router.replace({ path: "/home" });
      return;
    }

    if (this.$route.query.code) {
      localStorage.setItem("library_login_type", "partner");
      this.loginByCode(hostName, VUE_APP_ML_HOST);
      return;
    }

    this.redirectToPartnerIdt(hostName, VUE_APP_ML_HOST);
  },
};
</script>
